var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"containerOne"},[_c('div',{staticClass:"chartsGl",attrs:{"id":"charts"}}),_vm._v(" "),_c('div',{staticClass:"totalAge"},[_vm._v("\n    "+_vm._s(_vm.totalAge)),_c('span',{staticStyle:{"font-size":"20px","margin-left":"4px"}},[_vm._v("项")])]),_vm._v(" "),_c('div',{staticClass:"buttomCharts"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4de8586a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/patrolScreenMini/components/left/pieTu.vue
// module id = null
// module chunks = 